import { UserState } from "../../types";
import { FETCH_ALL_USERS_SUCCESS, UPDATE_USER_SUCCESS, LOGOUT_USER_REQUEST } from "../constants";

const initialState: UserState = {
  users: [],
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.allUsers,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: action.payload.allUsers,
      };
    case LOGOUT_USER_REQUEST:
      return initialState;
    default:
      return state;
  }
};
